// extracted by css-extract-rspack-plugin
export default {"poweredByGoogle":"_3b455770"};